import { FormGroup } from '@angular/forms';
import { FormulaireCoordonneesMouvementAdresseModel } from '../models/formulaire/formulaire-coordonnees-mouvement-adresse.model';
import { AdresseMouvement } from '../api/model/adresse-mouvement.model';
import { AdresseMouvementModification } from '../api/model/adresse-mouvement-modification.model';

export class MouvementUtil {
  private static readonly regSpaces: RegExp = /\s+/g;

  private static extractNumeroCiviqueEtNomRue(numeroCiviqueNomRue: string): {
    numeroCivique: string;
    nomRue: string;
  } {
    const [numeroCivique = '', ...rest] = numeroCiviqueNomRue.trim().split(this.regSpaces);
    return { numeroCivique, nomRue: rest.join(' ') };
  }

  private static cleanCodePostal(codePostal?: string | null): string | undefined {
    return codePostal ? codePostal.replaceAll(this.regSpaces, '') : undefined;
  }

  static toAdresseMouvement(
    form: FormGroup<FormulaireCoordonneesMouvementAdresseModel> | null | undefined,
  ): AdresseMouvement {
    const { numeroCivique, nomRue } = this.extractNumeroCiviqueEtNomRue(
      form?.value.numeroCiviqueNomRue ?? '',
    );
    return {
      numeroCivique,
      nomRue,
      numeroUnite: form?.value.appartement ?? undefined,
      nomMunicipalite: form?.value.ville ?? '',
      codeSubdivisionPays: this.getCodeSubdivisionPays(form ?? null),
      codePostal: this.cleanCodePostal(form?.value.codePostal),
      codePays: form?.value.codePays ?? '',
      dateDebutUtilisation: form?.value.dateDebutUtilisation ?? undefined,
    };
  }

  static toAdresseMouvementModification(
    form: FormGroup<FormulaireCoordonneesMouvementAdresseModel> | null,
    empreinte: string | undefined,
  ): AdresseMouvementModification {
    const { numeroCivique, nomRue } = this.extractNumeroCiviqueEtNomRue(
      form?.value.numeroCiviqueNomRue ?? '',
    );
    return {
      numeroCivique,
      nomRue,
      numeroUnite: form?.value.appartement ? form?.value.appartement : null,
      nomMunicipalite: form?.value.ville ?? '',
      codeSubdivisionPays: this.getCodeSubdivisionPays(form),
      codePostal: this.cleanCodePostal(form?.value.codePostal),
      codePays: form?.value.codePays ?? '',
      dateDebutUtilisation: form?.value.dateDebutUtilisation ?? undefined,
      empreinte,
    };
  }

  private static getCodeSubdivisionPays(
    form: FormGroup<FormulaireCoordonneesMouvementAdresseModel> | null,
  ): string | undefined {
    const pays = form?.getRawValue()?.codePays;
    const subdivision = form?.getRawValue()?.province;
    return subdivision ? `${pays}-${subdivision}` : undefined;
  }
}
